function StoreDetail() {
  return (
    <div className="container-fluid px-0">
      <div className="row m-0">
        <div className="col-12 px-0">
          <div className="categories_title text-center">
            <h2>Everything You Need, All in One Place</h2>
            <hr className="featured_underline mb-3 " />
          </div>
          <div className="store_details_text">
            <p>
              In today’s fast-moving world, finding a trusted and convenient
              online shopping platform is essential. We proudly offer one of the
              best online stores in Pakistan, bringing you a wide range of
              high-quality and affordable products — all in one place.
            </p>

            <p>
              ✈️ Whether you're a frequent traveler or planning your next trip,
              our <strong>travel accessories</strong> collection includes
              must-have items to make every journey easier and more enjoyable.
            </p>

            <p>
              🍽️ Discover smart and stylish <strong>kitchen tools</strong> that
              help make cooking faster, easier, and more fun — perfect for every
              home chef.
            </p>

            <p>
              👶 Your child’s comfort and safety matter. That’s why we offer
              carefully selected <strong>baby care products</strong>, including
              soft clothing, gentle skincare, and everyday baby essentials.
            </p>

            <p>
              🛁 Transform your bathroom into a relaxing space with our quality{' '}
              <strong>bathroom accessories</strong> — practical, stylish, and
              made to last.
            </p>

            <p>
              📱 Keep your devices powered and protected with our reliable{' '}
              <strong>mobile accessories</strong> — including cases, chargers,
              holders, and more.
            </p>

            <p>
              🏠 Our collection of <strong>household items</strong> includes
              cleaning tools, storage solutions, and everything you need to keep
              your home organized and running smoothly.
            </p>

            <p>
              Enjoy a smooth, secure, and satisfying shopping experience with
              Pakistan’s most trusted online store. We’re here to deliver
              quality, value, and convenience — right to your doorstep.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreDetail;
